import type { CreditLimitGroup } from '@/shared/api/resources';
import { moneyToInput, rateToInput } from '@/shared/lib/format';

/** O que a analise de credito da operacao sugere quando ainda nao tem nada gravado. */
export interface CamposSugeridosDoCredito {
  tradicional?: string;
  judicial?: string;
  taxaTradicional?: string;
  taxaJudicial?: string;
}

/** Grupos do tomador que cabem no limite judicial e financeiro da analise. */
const gruposDoJudicial = ['judicial', 'financeira'];

function aprovadoNoGrupo(
  limites: CreditLimitGroup[],
  grupo: string,
): string | undefined {
  const limite = limites.find((item) => item.modality_group === grupo);
  if (!limite?.configured || limite.approved.amount <= 0) return undefined;
  return moneyToInput(limite.approved);
}

/**
 * Sugestao da analise de credito da operacao (03/11/2026).
 *
 * A analise da operacao nascia com limite e taxa zerados, mesmo com o credito do tomador
 * aprovado em Limites e Taxas: quem aprovava o tomador tinha de digitar tudo de novo, e o
 * "Aprovar credito" do proximo passo recusava sem dizer onde. A sugestao e o limite
 * aprovado do tomador em cada grupo e, no grupo da modalidade, a taxa aplicada na
 * operacao. So preenche os campos: nada e gravado nem aprovado sem a pessoa.
 */
export function sugerirCamposDoCredito(
  limites: CreditLimitGroup[],
  grupo: string | undefined,
  taxaBps: number | undefined,
): CamposSugeridosDoCredito {
  const campos: CamposSugeridosDoCredito = {};
  const tradicional = aprovadoNoGrupo(limites, 'tradicional');
  if (tradicional) campos.tradicional = tradicional;
  const judicial = gruposDoJudicial
    .map((item) => aprovadoNoGrupo(limites, item))
    .find((valor) => valor !== undefined);
  if (judicial) campos.judicial = judicial;
  if (taxaBps && taxaBps > 0) {
    if (grupo === 'tradicional') campos.taxaTradicional = rateToInput(taxaBps);
    if (grupo && gruposDoJudicial.includes(grupo))
      campos.taxaJudicial = rateToInput(taxaBps);
  }
  return campos;
}
